/**
 * 재생 위치 이동 시 시작 전이나 음원 길이 뒤로 넘어가지 않도록 보정합니다.
 * 아직 전체 길이를 모르는 플레이어는 앞쪽 경계(0초)만 적용합니다.
 */
export function clampSeekTime(currentTime: number, duration: number | null, offsetSeconds: number): number {
  const safeCurrent = Number.isFinite(currentTime) ? currentTime : 0
  const upperBound = duration != null && Number.isFinite(duration) && duration > 0
    ? duration
    : Number.POSITIVE_INFINITY
  return Math.max(0, Math.min(upperBound, safeCurrent + offsetSeconds))
}

export const PLAYBACK_SEEK_STEPS = [-10, -5, -1, 1, 5, 10] as const
